import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "p-2"
};
const _hoisted_2 = {
  key: 1
};
import { computed, onMounted, reactive } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlTextField from '@/components/LlTextField.vue';
import LlTabs from '@/components/LlTabs.vue';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import { useCompanyBillingStore } from "@/modules/settings/integrations/QBO/companyBillingStore";
import { getSubscriptionType } from '@/services/utils';
import QuickbookProductService from '@/components/QuickbookProductService.vue';
export default {
  __name: 'ExpenseTemplateModal',
  props: {
    alerts: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: true
    },
    codeService: {
      type: Object,
      required: true
    },
    form: {
      type: Object,
      required: true
    },
    editingExpenseTemplate: {
      type: Object,
      required: true
    },
    editingTemplateId: {
      type: [String, Number],
      required: false
    },
    editExpenseTemplate: {
      type: Boolean,
      required: true
    },
    codes: {
      type: Object,
      required: true
    },
    tracking: {
      type: Object,
      required: false
    }
  },
  emits: ['updatedExpenseTemplate', 'deleteExpenseTemplate', 'closeModal'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const companyStore = useCompanyStore();
    const companyBillingStore = useCompanyBillingStore();
    companyStore.alerts = props.alerts;
    const expenseTemplateModal = reactive({
      loading: false,
      openExpenseTemplate: false,
      tab: null,
      form: {
        expenses: {
          label: '',
          amount: '',
          code: '',
          description: ''
        }
      },
      me: {},
      ledes: undefined,
      codes: {
        expense: []
      },
      isProcessing: false,
      selectedCode: null,
      accountingServices: {},
      selectedAccountingService: null
    });
    const isFormValid = computed(() => {
      return expenseTemplateModal.form.expenses.label && expenseTemplateModal.form.expenses.amount && expenseTemplateModal.form.expenses.description || expenseTemplateModal.selectedCode;
    });
    const templateTabs = computed(() => [{
      value: 1,
      label: 'Details'
    }, ...(expenseTemplateModal.me.features?.qboFixedFeeAndExpenseMapping ? [{
      value: 2,
      label: 'QuickBooks Mapping'
    }] : [])]);
    onMounted(async () => {
      expenseTemplateModal.loading = true;
      expenseTemplateModal.me = await props.userService.getMe();
      await companyBillingStore.getAccountingServices();
      expenseTemplateModal.accountingServices = companyBillingStore.accountingServices;
      expenseTemplateModal.ledes = expenseTemplateModal.me.company?.settings?.codes?.ledes;
      expenseTemplateModal.codes.expense = await props.codeService.expenseCodes();
      expenseTemplateModal.selectedCode = props.codes.expense.find(s => s.value === props.editingExpenseTemplate.code?.id);
      if (props.editingTemplateId === 0 || props.editingTemplateId) {
        expenseTemplateModal.form.expenses = props.editingExpenseTemplate;
        expenseTemplateModal.selectedAccountingService = expenseTemplateModal.accountingServices?.services?.find(s => s.id === props.editingExpenseTemplate?.accounting?.service?.id);
      } else {
        expenseTemplateModal.form.expenses = {};
        expenseTemplateModal.selectedAccountingService = null;
      }
      expenseTemplateModal.loading = false;
    });
    const updateExpenseTemplate = async () => {
      const expenses = props.form.expenses;
      if (props.editingTemplateId === 0 || props.editingTemplateId) {
        const index = props.editingTemplateId;
        expenses[index] = {
          amount: expenseTemplateModal.form.expenses.amount,
          description: expenseTemplateModal.form.expenses.description,
          label: expenseTemplateModal.form.expenses.label,
          code: {
            id: expenseTemplateModal.selectedCode?.id,
            label: expenseTemplateModal.selectedCode?.label
          },
          accounting: {
            service: expenseTemplateModal?.selectedAccountingService
          },
          saved: true
        };
      } else {
        const newExpense = {
          amount: expenseTemplateModal.form.expenses.amount,
          description: expenseTemplateModal.form.expenses.description,
          label: expenseTemplateModal.form.expenses.label,
          code: {
            id: expenseTemplateModal.selectedCode?.id,
            label: expenseTemplateModal.selectedCode?.label
          },
          accounting: {
            service: expenseTemplateModal?.selectedAccountingService
          },
          saved: true
        };
        expenses.push(newExpense);
      }
      expenses.standard = expenses.map(e => ({
        amount: e.amount,
        description: e.description,
        label: e.label,
        code: {
          id: e.code,
          label: props.codes.expense.find(s => s.value === e.code)?.label
        },
        accounting: {
          service: e.accounting?.service
        }
      }));
      await companyStore.updateMyCompany({
        settings: {
          expenses: {
            standard: expenses
          }
        }
      });
      props.tracking?.event(`${props.editingTemplateId === 0 || props.editingTemplateId ? "Update" : "Create"}`, "Expense Template", {
        company: expenseTemplateModal.me.company.name,
        user: {
          name: expenseTemplateModal.me.name,
          email: expenseTemplateModal.me.email
        },
        userRole: expenseTemplateModal.me.role,
        subscriptionType: getSubscriptionType(expenseTemplateModal.me.company.products),
        hasQboMapping: expenseTemplateModal?.selectedAccountingService ? true : false
      });
      emit('updatedExpenseTemplate');
      props.alerts?.success("Expense template updated Successfully");
    };
    const cancel = () => {
      emit('closeModal');
    };
    const deleteExpenseTemplate = () => {
      const deleteExpenseTemplateIndex = props.editingTemplateId;
      emit('deleteExpenseTemplate', deleteExpenseTemplateIndex);
    };
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_progress_circular = _resolveComponent("v-progress-circular");
      const _component_v_label = _resolveComponent("v-label");
      const _component_v_col = _resolveComponent("v-col");
      const _component_v_autocomplete = _resolveComponent("v-autocomplete");
      const _component_v_row = _resolveComponent("v-row");
      const _component_v_textarea = _resolveComponent("v-textarea");
      const _component_v_window_item = _resolveComponent("v-window-item");
      const _component_v_window = _resolveComponent("v-window");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_container = _resolveComponent("v-container");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      return _openBlock(), _createBlock(_component_v_card, {
        class: "mx-auto h-full",
        width: "700",
        height: "700"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_card_title, {
          class: "left justify-center"
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createElementVNode("h4", {
            class: "font-weight-bold"
          }, "Expense", -1)]))]),
          _: 1
        }), expenseTemplateModal.loading ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_v_progress_circular, {
          color: "success",
          indeterminate: ""
        })])) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(LlTabs, {
          modelValue: expenseTemplateModal.tab,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => expenseTemplateModal.tab = $event),
          items: templateTabs.value,
          density: "default"
        }, null, 8, ["modelValue", "items"]), _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [_createVNode(_component_v_window, {
            modelValue: expenseTemplateModal.tab,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => expenseTemplateModal.tab = $event),
            variant: "tonal",
            class: "w-full",
            style: {
              "min-height": "350px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_v_window_item, {
              value: 1,
              class: "window-item w-full",
              variant: "tonal"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_row, {
                class: "w-full d-flex flex-wrap"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_col, {
                  md: "5"
                }, {
                  default: _withCtx(() => [_createVNode(_component_v_label, {
                    class: "text-black"
                  }, {
                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("Label", -1)]))]),
                    _: 1
                  }), _createVNode(LlTextField, {
                    modelValue: expenseTemplateModal.form.expenses.label,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => expenseTemplateModal.form.expenses.label = $event),
                    variant: "outlined",
                    color: 'primary'
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_v_col, {
                  md: "2"
                }, {
                  default: _withCtx(() => [_createVNode(_component_v_label, {
                    class: "text-black"
                  }, {
                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("Amount", -1)]))]),
                    _: 1
                  }), _createVNode(LlTextField, {
                    modelValue: expenseTemplateModal.form.expenses.amount,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => expenseTemplateModal.form.expenses.amount = $event),
                    variant: "outlined",
                    type: "number",
                    color: 'primary'
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _withDirectives(_createVNode(_component_v_col, {
                  md: "5"
                }, {
                  default: _withCtx(() => [_createVNode(_component_v_label, {
                    class: "text-black"
                  }, {
                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("Code", -1)]))]),
                    _: 1
                  }), _createVNode(_component_v_autocomplete, {
                    items: __props.codes.expense,
                    modelValue: expenseTemplateModal.selectedCode,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => expenseTemplateModal.selectedCode = $event),
                    density: "compact",
                    "item-title": "label",
                    "item-value": "id",
                    "return-object": "",
                    clearable: "",
                    searchable: "",
                    variant: "outlined",
                    color: 'primary',
                    "hide-details": true,
                    "item-props": item => ({
                      disabled: item.disabled
                    })
                  }, null, 8, ["items", "modelValue", "item-props"])]),
                  _: 1
                }, 512), [[_vShow, expenseTemplateModal.ledes]])]),
                _: 1
              }), _createVNode(_component_v_row, {
                class: "w-full d-flex flex-wrap ga-0"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_col, null, {
                  default: _withCtx(() => [_createVNode(_component_v_label, {
                    class: "text-black"
                  }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("Invoice Description", -1)]))]),
                    _: 1
                  }), _createVNode(_component_v_textarea, {
                    rows: "8",
                    modelValue: expenseTemplateModal.form.expenses.description,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => expenseTemplateModal.form.expenses.description = $event),
                    variant: "outlined",
                    color: 'primary',
                    "auto-grow": "",
                    "max-height": "200"
                  }, null, 8, ["modelValue"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), expenseTemplateModal.me.features?.qboFixedFeeAndExpenseMapping ? (_openBlock(), _createBlock(QuickbookProductService, {
              key: 0,
              "tab-value": 2,
              services: expenseTemplateModal.accountingServices?.services,
              modelValue: expenseTemplateModal.selectedAccountingService,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => expenseTemplateModal.selectedAccountingService = $event),
              description: "Select the QuickBooks Product/Service to which the expense should map.",
              "additional-description": "This will map all the expenses that use this template to that Product/Service"
            }, null, 8, ["services", "modelValue"])) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_v_card_actions, {
          class: "flex flex-1 justify-end bg-gray-50 w-full actions"
        }, {
          default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_v_container, null, {
            default: _withCtx(() => [_createVNode(_component_v_row, {
              justify: "end",
              align: "end"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                cols: "auto"
              }, {
                default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                  onClick: _cache[7] || (_cache[7] = $event => cancel())
                }, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("Cancel", -1)]))]),
                  _: 1
                })]),
                _: 1
              }), __props.editExpenseTemplate ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "auto"
              }, {
                default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                  color: "error",
                  "prepend-icon": "mdi-trash-can-outline",
                  onClick: _cache[8] || (_cache[8] = $event => deleteExpenseTemplate())
                }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode(" Delete ", -1)]))]),
                  _: 1
                })]),
                _: 1
              })) : _createCommentVNode("", true), _createVNode(_component_v_col, {
                cols: "auto"
              }, {
                default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                  variant: "flat",
                  color: "primary",
                  onClick: _cache[9] || (_cache[9] = $event => updateExpenseTemplate()),
                  disabled: !isFormValid.value
                }, {
                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode(" Save Expense", -1)]))]),
                  _: 1
                }, 8, ["disabled"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        })]))]),
        _: 1
      });
    };
  }
};